import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/training')({
    staticData: {
        breadcrumb: {
            title: 'Training register',
        },
    },
    component: Outlet,
});
